/* Lukeva — silnik licznika „do północy" (Europe/Warsaw).
 *
 * Kontrakt (wspólny dla wszystkich sekcji motywu):
 *   - inicjalizuje KAŻDY element [data-lk-midnight] na stronie;
 *   - liczy sekundy do najbliższej północy czasu polskiego (Intl + timeZone 'Europe/Warsaw'),
 *     NIEZALEŻNIE od strefy czasowej przeglądarki; po północy startuje od 24:00:00 (doba);
 *   - wypełnia potomków [data-lk-hh] [data-lk-mm] [data-lk-ss] (zawsze 2 cyfry);
 *     gdy element ich nie ma — ustawia textContent „GG:MM:SS"
 *     (separator można zmienić atrybutem data-lk-sep, np. data-lk-sep=" : ");
 *   - zgodność wstecz z THEME_BASE_NOTES §5: data-lk-midnight="h" | "m" | "s" = samo pole;
 *   - jeden setInterval na stronę; elementy dodane później łapie MutationObserver
 *     (oraz ręcznie: window.lkMidnightInit()).
 *
 * Markup: <span data-lk-midnight><b data-lk-hh>00</b>:<b data-lk-mm>00</b>:<b data-lk-ss>00</b></span>
 *    albo: <span data-lk-midnight data-lk-sep=" : ">00 : 00 : 00</span>
 *
 * API: window.lkMidnight.secondsLeft()  -> liczba sekund (1..90000) do północy PL
 *      window.lkMidnight.parts()        -> {h, m, s, hh, mm, ss, total}
 *      window.lkMidnightInit()          -> ponowne skanowanie DOM + natychmiastowy tick
 * Ładowanie: layout raz na stronę; podwójne załadowanie jest bezpieczne (guard __lkMidnight).
 */
(function () {
  'use strict';

  if (window.__lkMidnight) {
    if (typeof window.lkMidnightInit === 'function') window.lkMidnightInit();
    return;
  }
  window.__lkMidnight = true;

  var TZ = 'Europe/Warsaw';
  var fmt = null;
  try {
    fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ,
      hourCycle: 'h23',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
    fmt.formatToParts(new Date()); /* starsze silniki bez formatToParts -> catch */
  } catch (e) {
    fmt = null;
  }

  /* Czas ścienny w Warszawie dla danego momentu: {y, mo, d, h, mi, s} */
  function wall(date) {
    if (!fmt) {
      return {
        y: date.getFullYear(), mo: date.getMonth() + 1, d: date.getDate(),
        h: date.getHours(), mi: date.getMinutes(), s: date.getSeconds()
      };
    }
    var p = fmt.formatToParts(date);
    var o = {};
    for (var i = 0; i < p.length; i++) o[p[i].type] = p[i].value;
    return {
      y: +o.year, mo: +o.month, d: +o.day,
      h: (+o.hour) % 24, /* niektóre silniki zwracają „24" o północy */
      mi: +o.minute, s: +o.second
    };
  }

  /* Przesunięcie strefy Warszawy względem UTC (ms) w danym momencie. */
  function offsetMs(date) {
    var w = wall(date);
    var asUtc = Date.UTC(w.y, w.mo - 1, w.d, w.h, w.mi, w.s);
    return asUtc - Math.floor(date.getTime() / 1000) * 1000;
  }

  /* Moment (epoch ms) najbliższej północy czasu polskiego — dokładnie, także w dni zmiany czasu. */
  function nextMidnight(now) {
    var w = wall(now);
    var midAsUtc = Date.UTC(w.y, w.mo - 1, w.d + 1, 0, 0, 0);
    var off = offsetMs(now);
    var t = midAsUtc - off;
    var off2 = offsetMs(new Date(t));
    if (off2 !== off) t = midAsUtc - off2;
    return t;
  }

  function secondsLeft() {
    var now = new Date();
    var s = Math.ceil((nextMidnight(now) - now.getTime()) / 1000);
    if (!(s > 0)) s = 86400;          /* dokładnie północ -> od nowa pełna doba */
    if (s > 90000) s = 90000;         /* bezpiecznik (doba 25 h przy zmianie czasu) */
    return s;
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function parts() {
    var total = secondsLeft();
    var h = Math.floor(total / 3600);
    var m = Math.floor((total % 3600) / 60);
    var s = total % 60;
    return { total: total, h: h, m: m, s: s, hh: pad(h), mm: pad(m), ss: pad(s) };
  }

  var els = [];
  var lastText = '';

  function scan() {
    els = Array.prototype.slice.call(document.querySelectorAll('[data-lk-midnight]'));
  }

  function setText(node, txt) {
    if (node && node.textContent !== txt) node.textContent = txt;
  }

  function paint(el, p) {
    var mode = el.getAttribute('data-lk-midnight');
    if (mode === 'h') return setText(el, p.hh);
    if (mode === 'm') return setText(el, p.mm);
    if (mode === 's') return setText(el, p.ss);
    var hh = el.querySelectorAll('[data-lk-hh]');
    var mm = el.querySelectorAll('[data-lk-mm]');
    var ss = el.querySelectorAll('[data-lk-ss]');
    if (hh.length || mm.length || ss.length) {
      var i;
      for (i = 0; i < hh.length; i++) setText(hh[i], p.hh);
      for (i = 0; i < mm.length; i++) setText(mm[i], p.mm);
      for (i = 0; i < ss.length; i++) setText(ss[i], p.ss);
      return;
    }
    var sep = el.getAttribute('data-lk-sep');
    if (sep === null) sep = ':';
    setText(el, p.hh + sep + p.mm + sep + p.ss);
  }

  function tick() {
    if (!els.length) return;
    var p = parts();
    lastText = p.hh + ':' + p.mm + ':' + p.ss;
    for (var i = 0; i < els.length; i++) {
      if (!els[i].isConnected) continue;
      paint(els[i], p);
    }
  }

  function init() {
    scan();
    tick();
  }

  window.lkMidnight = {
    secondsLeft: secondsLeft,
    parts: parts,
    tick: tick,
    last: function () { return lastText; }
  };
  window.lkMidnightInit = init;

  function start() {
    init();
    /* jeden interwał na stronę, wyrównany do pełnej sekundy */
    setTimeout(function () {
      tick();
      setInterval(tick, 1000);
    }, 1000 - (Date.now() % 1000) + 5);

    if ('MutationObserver' in window) {
      var pending = false;
      var mo = new MutationObserver(function (list) {
        if (pending) return;
        for (var i = 0; i < list.length; i++) {
          var added = list[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType === 1 && (n.hasAttribute('data-lk-midnight') || n.querySelector('[data-lk-midnight]'))) {
              pending = true;
              (window.requestAnimationFrame || setTimeout)(function () {
                pending = false;
                init();
              });
              return;
            }
          }
        }
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    }
    /* edytor motywu Shopify: przeładowanie sekcji */
    document.addEventListener('shopify:section:load', init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
